// Global "which requests are in flight" map, keyed by legacy request name
// (e.g. loading['REQUEST_USER_CUSTOMER']). Read via isLoadingByList in the editors.
//
// It originally matched only the hand-written action-type strings ('REQUEST_X' /
// 'REQUEST_X_SUCCESS'). After M6 the plain slices became RTK createSlice, whose
// action types are namespaced camelCase ('customer/requestUserCustomerSuccess'), so
// they no longer matched and loading stopped updating (the editor Loader never
// showed → uncontrolled inputs never remounted). This now handles both:
//   - legacy string actions: the still-manual `tree` slice (REQUEST_TREE, …)
//   - createSlice actions: 'slice/requestFoo[Success|Error]' → legacy key 'REQUEST_FOO'
// so isLoadingByList's existing lists keep working unchanged.
type LoadingState = Record<string, boolean>;

const requestReducer = (state: LoadingState = {}, action: { type: string }): LoadingState => {
  const type = action.type;

  // Legacy hand-written actions (tree slice): REQUEST_X / REQUEST_X_SUCCESS.
  if (type.includes('REQUEST_')) {
    const requestName = type.replace('_SUCCESS', '');
    const isLoading = !type.includes('_SUCCESS');
    return { ...state, [requestName]: isLoading };
  }

  // RTK createSlice request actions: 'slice/requestFoo[Success|Error]'.
  // Map to the legacy SCREAMING_SNAKE key so the editors' lists still match.
  if (type.includes('/request')) {
    let name = type.slice(type.indexOf('/') + 1);          // requestFooSuccess
    const isLoading = !/(Success|Error)$/.test(name);
    name = name.replace(/(Success|Error)$/, '');           // requestFoo
    const requestName = name.replace(/([A-Z])/g, '_$1').toUpperCase(); // REQUEST_FOO
    return { ...state, [requestName]: isLoading };
  }

  return state;
};

export default requestReducer;
